import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';
import { Textarea } from './ui/textarea';

interface CustomTextAreaProps {
    $centerText?: boolean;
    width?: string;
    height?: string;
    className?: string;
    style?: React.CSSProperties;
}

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    name: string;
}

export type BasicTextAreaProps = TextAreaProps & CustomTextAreaProps;

export const BasicTextArea = forwardRef<HTMLTextAreaElement, BasicTextAreaProps | CustomTextAreaProps>(
    ({ $centerText, width, height, className, style, ...props }, ref) => {
        return (
            <Textarea
                ref={ref}
                className={cn(
                    'h-auto px-3 py-3 text-base resize-none overflow-y-scroll font-inherit',
                    $centerText && 'text-center',
                    className,
                )}
                style={{ width: width || '100%', height: height || 'auto', ...style }}
                {...props}
            />
        );
    },
);

BasicTextArea.displayName = 'BasicTextArea';
